// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ContainerControl } from '../ContainerControl';
import DropDownSideBarTemplate from '@front/templates/DropDownSideBarTemplate.html';
import { Resources } from '@shared/localizations/Resources';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { AlertSideBarController } from '@shared/commons/SideBarController/AlertSideBarController';
export class DropDownSideBar extends ContainerControl {
    constructor() {
        super();
        // this.setFocus();
    }
    getType() {
        return 'DropDownSideBar';
    }
    oninit() {
        super.oninit();
        super.on('onCloseClick', this.hide);
        super.on('onUpdateHeader', this.localizeHeader);
        super.observe('activeSidePanel', this.changePanel);
    }
    changePanel() {
        this.setVisibleActivePanel();
        this.localizeHeader();
    }
    hide() {
        DropDownSideBar.ClosePanel.Raise();
    }
    setVisibleActivePanel() {
        const activeSide = super.get('activeSidePanel');
        const whichPanel = {
            Alert: false,
            Ideas: false,
            Notifications: false,
            VideoWidget: false
        };
        switch (activeSide) {
            case PanelNames.AlertPanel:
                whichPanel.Alert = true;
                break;
            case PanelNames.IdeasPanel:
                whichPanel.Ideas = true;
                break;
            case PanelNames.NotificationsPanel:
                whichPanel.Notifications = true;
                break;
            case PanelNames.VideoWidget:
                whichPanel.VideoWidget = true;
                break;
        }
        void this.set({ whichPanel });
    }
    localizeHeader() {
        const activeSide = super.get('activeSidePanel');
        switch (activeSide) {
            case PanelNames.AlertPanel:
                void super.set({
                    headerLocalText: Resources.getResource('screen.Alerts') + ('  (' + AlertSideBarController.getCountAlerts() + ')')
                });
                break;
            case PanelNames.IdeasPanel:
                void super.set('headerLocalText', Resources.getResource('panel.Ideas'));
                break;
            case PanelNames.NotificationsPanel:
                void super.set('headerLocalText', Resources.getResource('panel.Notifications'));
                break;
            case PanelNames.VideoWidget:
                void super.set('headerLocalText', Resources.getResource('panel.VideoWidget'));
                break;
        }
    }
    onMouseDown(event) {
        var _a;
        (_a = this.get('SideBarPanelRef')) === null || _a === void 0 ? void 0 : _a.onMouseDown(event, false);
        super.onMouseDown(event, false);
    }
}
DropDownSideBar.ClosePanel = new CustomEvent();
ContainerControl.extendWith(DropDownSideBar, {
    template: DropDownSideBarTemplate,
    data: function () {
        return {
            activeSidePanel: null,
            headerLocalText: '',
            SideBarPanelRef: null
        };
    }
});
